import React from 'react';
import PropTypes from 'prop-types';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

function SelectionPanel(props) {
    return (
        <List>
            <ListItem button onClick={() => props.onItemSelected(null, -1)} style={{ color: 'rgb(135, 142, 145)' }}>
                {props.listIcon &&
                    <ListItemIcon>{props.listIcon}</ListItemIcon>
                }
                <ListItemText>No Selection</ListItemText>
            </ListItem>
            <Divider />

            {props.items && props.items.map((item, index) =>
                <React.Fragment key={index}>
                    <ListItem button onClick={() => props.onItemSelected(item, index)}>
                        {props.listIcon &&
                            <ListItemIcon>{props.listIcon}</ListItemIcon>
                        }
                        <ListItemText>{item[props.displayProp]}</ListItemText>
                    </ListItem>
                    <Divider />
                </React.Fragment>
            )}
        </List>
    );
}

SelectionPanel.propTypes = {
    items: PropTypes.arrayOf(PropTypes.object),
    displayProp: PropTypes.string.isRequired,
    listIcon: PropTypes.element
};

export default SelectionPanel;